import normalizeWhitespace from "./normalizeWhitespace";
/**
 * Keeps the longest prefix whose normalized length is within `maxLength`.
 * Extra or repeated whitespace is preserved because it does not count after
 * `normalizeWhitespace`, matching submit-time validation.
 */
export default function clipToNormalizedMaxLength({ value, maxLength }) {
    if (normalizeWhitespace(value).length <= maxLength) {
        return value;
    }
    let acceptedPrefix = "";
    let rangeStart = 0;
    let rangeEnd = value.length;
    while (rangeStart <= rangeEnd) {
        const midpoint = Math.floor((rangeStart + rangeEnd) / 2);
        const prefix = value.slice(0, midpoint);
        if (normalizeWhitespace(prefix).length <= maxLength) {
            acceptedPrefix = prefix;
            rangeStart = midpoint + 1;
        }
        else {
            rangeEnd = midpoint - 1;
        }
    }
    return acceptedPrefix;
}
